<template>
    <b-container class="py-4 text-center">
      <h2>Welcome 👋</h2>
      <h5>Vidon clones your sales team letting you automate engaging personalised videos. 💪</h5>
      <b-card-group class="mt-4" deck>
        <b-card title="Step 1">
          Create your first video
          <p><small>less the a minute</small></p>
        </b-card>
        <b-card title="Step 2">
          Clone your voice
          <p><small>20 minutes</small></p>
        </b-card>
        <b-card title="Step 3">
          Wait for our AI to learn
          <p><small>12-24 hours</small></p>
        </b-card>
      </b-card-group>

      <b-button size="lg" variant="primary" class="mt-4 mb-2" @click="next_step">Get started</b-button>
      <br />
      <b-link v-if="profile.role === 'admin'" :to="{name: 'dashboard'}">Skip</b-link>
    </b-container>
</template>

<script>

import { db, config, FieldValue } from '@/main.js'
import moment from 'moment/src/moment'

export default {
  metaInfo: {title: 'Onboarding welcome'},
  props: ['profile', 'user'],
  methods: {
    async next_step() {
      await db.collection('user').doc(this.profile.id).update({updated: new Date(), onboarding_step: 'video'})
      this.$router.push({name: 'onboarding_video'})
    },
    goto_step(val) {
      if (val && val.onboarding_step === 'video') {
        this.$router.push({name: 'onboarding_video'})
      } else if (val && val.onboarding_step === 'voice') {
        this.$router.push({name: 'onboarding_voice'})
      } else if (val && val.onboarding_step === 'wait' && val.team.plan !== undefined && val.team.plan === null) {
        this.$router.push({name: 'onboarding_wait'})
      } else if (val && ((val.onboarding_step === 'wait' && val.team.plan !== null) || val.onboarding_step === 'complete')) {
        this.$router.push({name: 'dashboard'})
      }
    }
  },
  watch: {
    'profile': {
      deep: true,
      handler: function(val) {
        this.goto_step(val)
      }
    }
  },
  mounted() {
    this.goto_step(this.profile)

    if (window.HubSpotConversations && window.HubSpotConversations.widget) {
      window.HubSpotConversations.widget.refresh()
    }
  }
}
</script>

<style scoped>

</style>
